import React from 'react';

const Spacer = ({ height }) => (
  <div style={{ height, background: '#222f39' }} className="card-nt" />
);

export default Spacer;
